import { cloneDeep } from "lodash";

import {
  // Common actions
  UPDATE_COMMON_CONFIG,
  UPDATE_OPTION_CONFIG,
  UPDATE_IS_VISIBILITY_ERROR,

  // Flag actions
  UPDATE_IS_DATA_LOADED,
  UPDATE_IS_LOADING,
  UPDATE_IS_BACKGROUND_LOADING,

  // Data actions
  UPDATE_VISIBILITY_COLUMN,
  UPDATE_VISIBILITY_ROW,
  UPDATE_VISIBILITY_DATA,
  UPDATE_VISIBILITY_CELL,
  COPY_VISIBILITY_CONFIG_TO_PDF,
  UPDATE_BACKUP_DATA,
  COPY_BACKUP_DATA,
  RESET_VISIBILITY_DATA,
  UPDATE_RAW_DATA,
} from "./action";

// helper
import { modifyCopyData } from "./helper";

const initialState = {
  // Common
  commonConfig: null,
  optionConfig: null,
  isVisibilityError: null,
  web: {
    // Data flags
    isDataLoaded: false,
    isLoading: false,
    isBackgroundLoading: false,

    // Data
    column: null,
    row: null,
    data: null,
    backupData: null,

    rawData: null,
  },
  pdf: {
    // Data flags
    isDataLoaded: false,
    isLoading: false,
    isBackgroundLoading: false,

    // Data
    column: null,
    row: null,
    data: null,
    backupData: null,

    rawData: null,
  },
};

const visibilityTab = (state = initialState, action) => {
  switch (action.type) {
    case UPDATE_COMMON_CONFIG: {
      const { commonConfig } = action.payload;
      return {
        ...state,
        commonConfig,
      };
    }

    case UPDATE_OPTION_CONFIG: {
      const { optionConfig } = action.payload;
      return {
        ...state,
        optionConfig,
      };
    }

    case UPDATE_IS_VISIBILITY_ERROR: {
      const { isVisibilityError } = action.payload;

      return {
        ...state,
        isVisibilityError,
      };
    }

    case UPDATE_IS_DATA_LOADED: {
      const { type, isDataLoaded } = action.payload;
      return {
        ...state,
        [type]: {
          ...state[type],
          isDataLoaded,
        },
      };
    }

    case UPDATE_IS_LOADING: {
      const { type, isLoading } = action.payload;
      return {
        ...state,
        [type]: {
          ...state[type],
          isLoading,
        },
      };
    }

    case UPDATE_IS_BACKGROUND_LOADING: {
      const { type, isBackgroundLoading } = action.payload;
      return {
        ...state,
        [type]: {
          ...state[type],
          isBackgroundLoading,
        },
      };
    }

    case UPDATE_VISIBILITY_COLUMN: {
      const { type, column } = action.payload;
      return {
        ...state,
        [type]: {
          ...state[type],
          column,
        },
      };
    }

    case UPDATE_VISIBILITY_ROW: {
      const { type, row } = action.payload;
      return {
        ...state,
        [type]: {
          ...state[type],
          row,
        },
      };
    }

    case UPDATE_VISIBILITY_DATA: {
      const { type, data } = action.payload;
      return {
        ...state,
        [type]: {
          ...state[type],
          data,
        },
      };
    }

    case UPDATE_VISIBILITY_CELL: {
      const { type, reviewerTypeId, roleTypeId, optionId } = action.payload;

      return {
        ...state,
        [type]: {
          ...state[type],
          data: {
            ...state[type].data,
            [roleTypeId]: {
              ...state[type].data[roleTypeId],
              [reviewerTypeId]: {
                ...state[type].data[roleTypeId][reviewerTypeId],
                visibility: optionId,
              },
            },
          },
        },
      };
    }

    case COPY_VISIBILITY_CONFIG_TO_PDF: {
      const pdfData = modifyCopyData(state.web);

      return {
        ...state,
        pdf: pdfData,
      };
    }

    case UPDATE_BACKUP_DATA: {
      const { type, data } = action.payload;

      return {
        ...state,
        [type]: {
          ...state[type],
          backupData: cloneDeep(data),
        },
      };
    }

    case COPY_BACKUP_DATA: {
      return {
        ...state,
        web: {
          ...state.web,
          backupData: state.web?.data ? cloneDeep(state.web?.data) : null,
        },
        pdf: {
          ...state.pdf,
          backupData: state.pdf?.data ? cloneDeep(state.pdf?.data) : null,
        },
      };
    }

    case RESET_VISIBILITY_DATA: {
      return {
        ...initialState,
      };
    }

    case UPDATE_RAW_DATA: {
      const { type, data } = action.payload;
      return {
        ...state,
        [type]: { ...state[type], rawData: data },
      };
    }

    default:
      return state;
  }
};

export default visibilityTab;
